// import $ from 'jquery';
// import debug from 'debug';

class QuoteCtaController {
	constructor(element, options) {
		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.submitButtons = [... this.element.querySelectorAll(this.options.submitButtonSelector)];
		this.collapsibles = [...this.element.querySelectorAll(this.options.collapsiblesSelector)];
		
		this.watch();
	}

	watch(){
		this.$element.on('closeothers', this.closeOtherCollapsibles.bind(this));
		$(this.collapsibles).on('closeAll', this.closeAllCollapsibles.bind(this));
		this.submitButtons.forEach((button) => {
			button.addEventListener('click', this.setAction.bind(this));
		});
	}

	setAction(event) {
		const button = event.currentTarget;
		const url = button.dataset.action;
		if (url) {
			this.element.action = url;
		}
	}

	closeAllCollapsibles(){
		const toClose = this.collapsibles;

		toClose.forEach(function(item){
			item.dataset.collapsibleOpen = false;
		});
	}

	closeOtherCollapsibles(event){
		const opening = event.target;
		const toClose = this.collapsibles.filter(function(item) {
			return item !== opening;
		});

		toClose.forEach(function(item){
			item.dataset.collapsibleOpen = false;
		});
	}
}

QuoteCtaController.DEFAULTS = {};

export default QuoteCtaController;



// WEBPACK FOOTER //
// ./project/client/src/core/modules/quote-cta/quote-cta.js